const CONTACT_INFO_DELIMITER = ' | ';

/**
 * Display name for the Name/Function column: for nonradio use contact/channel
 * name first; for radio use function first.
 */
export function getComDisplayName(com: {
  type?: string;
  channel_name?: string;
  name?: string;
  function?: string;
}): string {
  const t = (com.type ?? '').toLowerCase();
  if (t === 'nonradio') {
    return com.channel_name ?? com.name ?? com.function ?? '—';
  }
  return com.function ?? com.channel_name ?? com.name ?? '—';
}

const CONTACT_INFO_LABELS = {
  rxFrequency: 'RX Freq',
  rxToneNac: 'RX Tone/NAC',
  txFrequency: 'TX Freq',
  txToneNac: 'TX Tone/NAC',
  mode: 'Mode',
  cellPhoneNumber: 'Cell',
  other: 'Other',
  channelNumber: 'Channel #',
  zoneGroup: 'Zone/Group',
} as const;

type ComForContactInfo = {
  rx_frequency?: string;
  rx_tone_nac?: string;
  tx_frequency?: string;
  tx_tone_nac?: string;
  mode?: string;
  cell_phone_number?: string;
  other?: string;
  channel_number?: string;
  zone_group?: string;
};

/**
 * Build ICS-204 Contact Information string from ICS-205 com fields with labels.
 * Includes radio fields (RX Freq through Mode) and non-radio fields (Cell,
 * Other, Channel #, Zone/Group).
 */
export function buildContactInfoFromIcs205Com(com: ComForContactInfo): string {
  const labeled = (
    label: string,
    value: string | null | undefined
  ): string | null =>
    value != null && String(value).trim() !== ''
      ? `${label}: ${String(value).trim()}`
      : null;
  const parts = [
    labeled(CONTACT_INFO_LABELS.rxFrequency, com.rx_frequency),
    labeled(CONTACT_INFO_LABELS.rxToneNac, com.rx_tone_nac),
    labeled(CONTACT_INFO_LABELS.txFrequency, com.tx_frequency),
    labeled(CONTACT_INFO_LABELS.txToneNac, com.tx_tone_nac),
    labeled(CONTACT_INFO_LABELS.mode, com.mode),
    labeled(CONTACT_INFO_LABELS.cellPhoneNumber, com.cell_phone_number),
    labeled(CONTACT_INFO_LABELS.other, com.other),
    labeled(CONTACT_INFO_LABELS.channelNumber, com.channel_number),
    labeled(CONTACT_INFO_LABELS.zoneGroup, com.zone_group),
  ].filter((s): s is string => s != null);
  return parts.join(CONTACT_INFO_DELIMITER);
}

export const getTacticName = (
  workAssignment: any,
  incidentTactics: any[] | undefined
): string | null => {
  if (workAssignment.incident_tactic_id && incidentTactics) {
    const tactic = incidentTactics.find(
      (t) => String(t.id) === String(workAssignment.incident_tactic_id)
    );
    return tactic?.name || 'Unknown Tactic';
  }
  return null;
};
